module.exports = __webpack_public_path__ + "static/007187-72fb7c8e408914de347ce5bfb87e10b1.jpg";